import { ResultOf } from '@graphql-typed-document-node/core';
import { parseISO } from 'date-fns';
import { useState } from 'react';

import { isIntervalActive } from '../../../common/date-util';
import { EpochDate } from '../../../common/util';
import { graphql } from '../../../generated/gql';

export const getProjectLocation = graphql(`
  query GetProjectLocation($projectKey: String!) {
    project(projectKey: $projectKey) {
      id
      latitude
      longitude
    }
  }
`);

export const mapDataQueryDocument = graphql(`
  query GetMapData($projectKey: String!) {
    project(projectKey: $projectKey) {
      id
      measuringPoints {
        id
        number
        longitude
        latitude
        address
        crs
        z
        v10
        v1
        v2
        noise
        underground
        typeOfWork
        fixedBenchmark
        airblast
        isAddedOnMap
      }
      measuringCards(includeDormant: true) {
        id
        validFrom
        validTo
        isActive
        channels(measuringCardChannelType: "ALL") {
          id
          channel
          type
          sensor
          hiredFrom
          hiredTo
          measuringCardId
          measuringPointId
          isActive
        }
      }
    }
  }
`);

type GetMapDataResult = ResultOf<typeof mapDataQueryDocument>;

type MeasuringPoint = NonNullable<
  NonNullable<
    NonNullable<GetMapDataResult['project']>['measuringPoints']
  >[number]
>;

type MeasuringCard = NonNullable<
  NonNullable<
    NonNullable<GetMapDataResult['project']>['measuringCards']
  >[number]
>;

type MeasuringCardChannel = NonNullable<
  NonNullable<MeasuringCard['channels']>[number]
>;

export interface MeasuringPointExt extends MeasuringPoint {
  type?: string;
  projectKey?: string;
  cards: MeasuringCard[];
  channels: MeasuringCardChannel[];
}

export interface TypeFilter {
  name: string;
  prefix: string;
  show: boolean;
}
export interface MapFilter {
  showActive: boolean;
  showInactive: boolean;
  showBlasts: boolean;
  from: Date;
  to: Date;
  types: TypeFilter[];
}

export const useMapFilter = () =>
  useState<MapFilter>(() => ({
    showActive: true,
    showInactive: false,
    showBlasts: true,
    from: EpochDate,
    to: new Date(),
    types: [
      {
        name: 'Vibration',
        prefix: 'Mark',
        show: true,
      },
      {
        name: 'Acceleration',
        prefix: 'Accel',
        show: true,
      },
      {
        name: 'Luftstöt',
        prefix: 'Luftstöt',
        show: true,
      },
      { name: 'Buller', prefix: 'Buller', show: true },
      {
        name: 'Stomljud',
        prefix: 'Stomljud',
        show: true,
      },
    ],
  }));

export const isMeasuringPointActive = (measuringPoint: MeasuringPointExt) =>
  measuringPoint?.cards
    .filter((x) => x.validFrom != null && x.validTo != null)
    .some((x) =>
      isIntervalActive(parseISO(x.validFrom!), parseISO(x.validTo!))
    );
